import { render, staticRenderFns } from "./jigsaw.vue?vue&type=template&id=12f9a8e0&scoped=true&"
import script from "./jigsaw.vue?vue&type=script&lang=js&"
export * from "./jigsaw.vue?vue&type=script&lang=js&"
import style0 from "./jigsaw.vue?vue&type=style&index=0&id=12f9a8e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f9a8e0",
  null
  
)

export default component.exports